// extracted by mini-css-extract-plugin
export default {"timer":"CountDown_timer__w8wIz"};